import Header from 'components/layout/header';
import MobileHeader from 'components/layout/MobileHeader';
// import MobileSettingHeader from 'components/layout/MobileSettingHeader';
import SideBar from 'components/layout/sideBar';
// import ChatBubble from 'components/ChatBubble';
import UnifiedChatList from 'components/layout/UnifiedChatList';
import React, { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Switch } from 'react-router';
import ProtectedRoute from './ProtectedRoute';
import { appRoutes } from './router';
import { 
  //useRouteMatch, 
  useLocation, useHistory } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
// import { useCounselor } from 'hooks/useCounselor';

interface Props {}

const DashBoardLayout = (props: Props) => {
  // const match = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const isDashboard =
    // location.pathname === '/payment/upgrade-plan' ||
    location.pathname === '/dashboard' ||
    location.pathname === '/dashboard/' ||
    location.pathname === '/dashboard/children';
  const [title, setTitle] = React.useState('Dashboard');
  // const { counselor, loading: counselorLoading } = useCounselor();
  const basicInformation = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const role  = basicInformation?.user_role ?? '';
   
  useEffect(() => {
    if (location.pathname.startsWith('/support')) {
      setTitle('Support');
    }
    else if (location.pathname.startsWith('/settings')) {
      setTitle('Settings');
    }
    else if (location.pathname === '/dashboard/upgrade') {
      setTitle('Choose a Plan');
    } 
    else if (location.pathname === '/payment/upgrade-plan') {
      setTitle('Upgrade your Plan');
    }    
    else if ((location.pathname === '/dashboard' || location.pathname === '/dashboard/children') && role === 'parent')  {
      setTitle('');
    } 
    else if (location.pathname.startsWith('/dashboard/student/')) {
      setTitle('Student Profile');
    } 
    else {
      setTitle('Dashboard');
    }
  }, [location.pathname, role]);

  useEffect(() => {
    sessionStorage.setItem('userRole', role);
  }, [role]);

  // Sync URL role param with actual user role (fixes parent seeing role=counselor in URL)
  // useEffect(() => {
  //   if (!role) return;
  //   const urlRole = new URLSearchParams(location.search).get('role');
  //   if (urlRole && urlRole.toLowerCase() !== role.toLowerCase()) {
  //     const params = new URLSearchParams(location.search);
  //     params.set('role', role);
  //     history.replace({ ...location, search: params.toString() });
  //   }
  // }, [role, location.search, location.pathname]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('rollback') === '1') {
      console.log('System recovery: User has canceled Stripe payment.');
      
      // Example: Display Toast if you have a notification library:
      // toast.warning("You have canceled your payment. Your old service plan has been preserved.");
      // Clean the URL address bar
      params.delete('rollback');
      const newSearch = params.toString();
      history.replace({
        pathname: location.pathname,
        search: newSearch ? `?${newSearch}` : '',
      });
    }
  }, [location.search, location.pathname, history]);

  
  // Check if user is student and has necessary information for chat
  // const shouldShowChatBubble = role === 'student' && basicInformation?.id && counselor;
  
  return (
    <Container fluid className="vh-100 overflow-hidden px-0" style={{ position: 'relative' }}>
        <div className="d-none d-sm-block w-100">
          <Header title={title} />
        </div>
        <div className="d-block d-sm-none w-100">
            <MobileHeader />
        </div>
        <div className="gm-content">
          {!isDashboard && (
            <div className="d-none d-sm-block gm-sidebar">
              <SideBar hideList />
            </div>
          )}
          <div className="gm-main-content" style={isDashboard ? { width: '100%' } : undefined}>
            <Switch>
              {Object.keys(appRoutes).map((route: any, index: any) => {
                return (
                  <ProtectedRoute
                    key={index}
                    path={appRoutes[route].path}
                    component={appRoutes[route].component}
                    exact
                  />
                );
              })}
            </Switch>
          </div>
        </div>
        
        {/* Chat Bubble - Only show for students */}
        {/* {shouldShowChatBubble && counselor && (
          <ChatBubble
            userId={basicInformation.student_id}
            userType="student"
            counselorName={counselor.name}
            studentName={`${basicInformation.first_name || ''} ${basicInformation.last_name || ''}`.trim() || 'Student'}
            studentId={basicInformation.student_id || basicInformation.id}
            counselorId={counselor.id}
          />
        )} */}

        {/* Unified Chat List - Show for all roles when toggled */}
        <UnifiedChatList />
      </Container>
  );
};

export default DashBoardLayout;
